import React from 'react';
import classnames from 'classnames';

import './style.scss';

export interface IChipProps {
  children?: React.ReactNode;
  active?: boolean;
  onClick?: (e?: React.SyntheticEvent<any>) => void;
  onClose?: (e?: React.SyntheticEvent<any>) => void;
}

const Chip: React.FunctionComponent<IChipProps> = ({ children, onClick, onClose, active }) => {
  const closeLabel =
    typeof children === 'string' || typeof children === 'number' ? `Remove ${children}` : 'Remove';

  return (
    <div
      className={classnames('chip__wrapper', {
        active,
        closable: !!onClose,
        clickable: !!onClick,
      })}
    >
      <div className={classnames('chip__body')} onClick={onClick}>
        {children}
      </div>
      {onClose && (
        <button
          type="button"
          className={classnames('chip__close-button')}
          onClick={onClose}
          aria-label={closeLabel}
        />
      )}
    </div>
  );
};

export default Chip;
